<template>
	<div id="Agenda">
		<b-card class="mb-4 hide-on-print" variant="default">
			<agenda-filtros-generales
				:debug="debug"
				v-model="selectFilters"
				@change="update"
			/>
		</b-card>

		<div v-if="isLoading">
			<ui-spinner />
		</div>

		<template v-else-if="selectFilters.cede_id">
			
            <agenda-grupo-totalizador :data="data.agendaordenes"  v-if="displayAgendaTotalizador"/>
			
			<template v-if="selectFilters.tipo == 'escuela'">
				<grupo-agenda-viewer v-for="grupo in data.groups"
					:edit-mode="selectFilters.editMode"
					:filter-by="filterLunchPresenceByCedeType"
					:key="'grupo-' + grupo.id + '-' + md5Stamp"
					:grupoId="grupo.id"
					:getData="getData"
					:debug="debug"
					:select-filters="selectFilters"
					@reload="backgroundUpdate" @forceUpdate="update"
				/>
			</template>

			<empresa-agenda-viewer
				v-else-if="selectFilters.tipo == 'empresa'"
				:key="'empresa-agenda-' + selectFilters.cede_id + '-' + md5Stamp"
				:edit-mode="selectFilters.editMode" :debug="debug"
				:filter-by="filterLunchPresenceByCedeType"
				:getData="getData" :select-filters="selectFilters"
				class="mb-3"
				@reload="backgroundUpdate" @forceUpdate="update"/>
			
		    <agenda-grupo-totalizador :data="data.agendaordenes"  v-if="displayAgendaTotalizador"/>
		</template>
		
		<CocinaeasylunchreporteQuicktable v-else key="CocinaeasylunchreporteQuicktable" class="mb-4" />

	</div>
</template>

<script>
import _ from "lodash";
import AgendaFiltrosGenerales from "./Agenda/agendaFiltrosGenerales.vue";
import EasylunchQuicktable from "./Agenda/quicktable.vue";
import { getLunchAgenda, agendaArchetype, selectFilters } from "./Agenda/archetype.js";
import { notify } from "@/utils.js";
import GrupoAgendaViewer from "./Agenda/grupoAgendaViewer.vue";
import empresaAgendaViewer from "./Agenda/empresaAgendaViewer.vue";
import AgendaGrupoTotalizador from "./Agenda/agendaGrupoTotalizador.vue";
import md5 from 'js-md5'
import CocinaeasylunchreporteQuicktable from "../Cocinaeasylunchreporte/CocinaeasylunchreporteQuicktable.vue";

export default {
	name: "LunchAgenda",

	components: {
		EasylunchQuicktable,
		AgendaFiltrosGenerales,
		GrupoAgendaViewer, 
		empresaAgendaViewer,
		AgendaGrupoTotalizador,
		CocinaeasylunchreporteQuicktable
	},

	data: () => {
		return {
			isLoading: false,
			debug: false,
			selectFilters: _.clone(selectFilters),
			md5Stamp: null,
			data: _.cloneDeep(agendaArchetype),
		};
	},

	computed: {
		displayAgendaTotalizador(){
			return (this.data.agendaordenes.length && this.selectFilters.tipo == 'escuela')
		},
		filterLunchPresenceByCedeType(){
			let matrix = {
				'escuela': 'alumno',
				'empresa': 'directo'
			}
			return matrix[this.selectFilters.tipo];
		}
	},

	methods: {
		getData() {
			return this.data;
		},
		async backgroundUpdate(){
			let data = _.cloneDeep(agendaArchetype);
			try {
				let response = await getLunchAgenda(this.selectFilters);
				if (!_.isObjectLike(response))
					throw "Error en la consulta o la conexión para cancelado";
				if (response.status) data = _.merge(data, response.data);
				console.log("data", data);
			} catch (e) {
				notify(e);
			}
			this.data = data;
			this.md5Stamp = md5(JSON.stringify(data))
		},
		async update() {
			this.isLoading = true;
			await this.backgroundUpdate()
			this.isLoading = false;
		},
	},
};
</script>